export * from './campaign-domains.component';
